<template>
  <CRow class="mt-5 pt-5">
    <CCol sm="12" class="d-flex flex-column mb-5 p-0">
      <h1 class="titlePage font-weight-normal text-capitalize">
        {{ $t('templates.email.importHtml.title') }}
      </h1>
      <a
        @click="back"
        class="mt-3 text-decoration-none d-flex-inline align-items-center font-weight-normal text-gray-600 cursor-pointer text-uppercase"
      >
        <CIcon name="arrow" :height="20" class="icon__rotateLeft mr-2" viewBox="0 0 32 32" />
        {{ $t('general.link.back') }}
      </a>
    </CCol>
    <CCol sm="12">
      <transition name="fade">
        <MenssageAlert :messages="messagesSend" />
      </transition>

      <div v-if="loading" style="min-height: 300px" class="d-flex justify-content-center align-items-center dataTable__loading">
        <CSpinner class="my-3" color="primary" />
      </div>

      <template>
        <CRow class="align-items-end align-items-sm-stretch" v-show="!loading" :style="{ opacity: !loading ? 1 : 0 }">
          <CCol sm="12" md="12" lg="5">
            <div>
              <h3 class="font-weight-normal">{{ $t('templates.email.importHtml.name') }}</h3>
              <CInput placeholder="Template Name" class="my-4" v-model="templateName"> </CInput>
            </div>
            <h3 class="font-weight-normal">
              {{ $t('templates.email.importHtml.import-from-my-computer') }}
            </h3>
            <p class="text-gray-600 font-sm">
              {{ $t('templates.email.importHtml.html-must-unsubscribe') }}
            </p>

            <div class="box d-flex flex-column mt-3 px-5 py-4">
              <div>
                <h6 class="font-weight-normal mb-1">{{ $t('templates.email.importHtml.html-page') }}</h6>
                <div class="text-max-size mb-2">*{{ $t('templates.email.importHtml.error.sizeFile') }}</div>
                <div class="d-flex align-items-center">
                  <div class="inputUpload" :class="{ 'inputUpload--disabled': urlField.length > 0 }">
                    <CIcon name="upload" :height="18" class="px-3 text-gray-700" viewBox="0 0 32 32" />
                    <CInputFile
                      class="border: 1px black solid"
                      name="teste"
                      color="primary"
                      :label="$t('templates.email.importHtml.upload-file')"
                      :disabled="urlField.length > 0"
                      :value.sync="htmlFileName"
                      @change="(val) => getfile(val, 'html')"
                    />
                  </div>
                  <div class="m-0 px- font-sm inputUpload__nameFile" v-if="html.name">
                    File name: <b class="text-secondary mx-1">{{ html.name }}</b>
                    <CButton @click="clearUpload('html')" style="width: 50px">
                      <CIcon name="refused" :height="18" class="text-gray-700" viewBox="0 0 32 32" />
                    </CButton>
                  </div>
                </div>
              </div>

              <div>
                <p class="text-gray-600 font-sm mt-3 mb-0">
                  {{ $t('templates.email.importHtml.all-other-image') }}
                </p>
                <div class="d-flex align-items-center">
                  <div class="inputUpload" :class="{ 'inputUpload--disabled': urlField.length > 0 }">
                    <CIcon name="upload" :height="18" class="px-3 text-gray-700" viewBox="0 0 32 32" />
                    <CInputFile
                      class=""
                      :label="$t('templates.email.importHtml.upload-file')"
                      :disabled="urlField.length > 0"
                      :value.sync="zipFileName"
                      @change="(val, type) => getfile(val, 'zip')"
                    />
                  </div>
                  <div class="m-0 px-2 font-sm inputUpload__nameFile" v-if="zip.name">
                    {{ $t('templates.email.importHtml.file-name') }} <b class="text-secondary mx-1">{{ zip.name }}</b>
                    <CButton @click="clearUpload('zip')" style="width: 50px">
                      <CIcon name="refused" :height="18" class="text-gray-700" viewBox="0 0 32 32" />
                    </CButton>
                  </div>
                </div>
              </div>
            </div>
            <transition name="fade">
              <MenssageAlert :messages="messages" />
            </transition>
          </CCol>

          <CCol sm="0" md="1" class="d-flex align-items-center justify-content-center pt-5"> {{ $t('templates.email.importHtml.or') }}</CCol>

          <CCol sm="12" md="12" lg="5" class="d-flex flex-column justify-content-end">
            <h3 class="font-weight-normal">{{ $t('templates.email.importHtml.import-from-the-web') }}</h3>
            <p class="text-gray-600 font-sm">
              {{ $t('templates.email.importHtml.current-address') }}
            </p>

            <div class="box d-flex flex-row align-items-center mt-3 px-5 py-4 w-100">
              <CInput
                type="text"
                placeholder="http://"
                :label="$t('templates.email.importHtml.url')"
                :disabled="html.name || zip.name"
                v-model="$v.urlField.$model"
                :isValid="checkIfValid('urlField')"
                :invalidFeedback="'This is a field must be valid URL address'"
                class="w-100"
              />
            </div>
          </CCol>
          <CCol sm="12">
            <CButton
              @click="submit"
              v-if="!messages.lenght"
              color="primary"
              class="px-4 py-2 mt-4"
              :disabled="!html.name && $v.urlField.$model.length && $v.urlField.$invalid"
            >
              {{ $t('templates.email.importHtml.import') }}
            </CButton>
          </CCol>
        </CRow>
      </template>
    </CCol>
  </CRow>
</template>

<script>
import MenssageAlert from '@/components/MenssageAlert'
import { validationMixin } from 'vuelidate'
import { url } from 'vuelidate/lib/validators'
import services from '@/services.js'
import { DYNAMIC_TEMPLATE_DESTINATION_TYPE } from '@/views/template/constants'
import { getErrorMessage } from '@/utils/errorHandling.js'

export default {
  name: 'ImporHTML',
  components: {
    MenssageAlert,
  },
  data() {
    return {
      templateName: '',
      html: {},
      htmlFileName: '',
      zip: {},
      zipFileName: '',
      urlField: '',
      messages: [],
      messagesSend: [],
      loading: false,
    }
  },
  mixins: [validationMixin],
  validations: {
    urlField: {
      url,
    },
  },
  computed: {
    isDestinationTypeCampaign() {
      return DYNAMIC_TEMPLATE_DESTINATION_TYPE.CAMPAIGN == this.$route.params.dynamicDestinationType
    },

    isDestinationTypeWorkflow() {
      return DYNAMIC_TEMPLATE_DESTINATION_TYPE.WORKFLOW == this.$route.params.dynamicDestinationType
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v[fieldName]
      if (!field.$dirty) {
        return null
      }
      return !(field.$invalid || null)
    },
    getfile(file, type) {
      this.messagesSend = []
      if (file[0].size / 1000000 > 1.024) {
        this.messagesSend.push({
          status: 'danger',
          text: this.$t('templates.email.importHtml.error.sizeFile'),
        })
        return
      }

      if (this.isvalid(file[0].type, type)) {
        this[type] = file[0]
        return
      }

      this.messages.push({
        status: 'danger',
        text: `Only ${type} file`,
      })

      this[`${type}FileName`] = ''
      this[type] = {}
    },

    isvalid(typeFile, fieldType) {
      this.messages = []

      if (fieldType == 'html' || fieldType == 'zip') {
        if (typeFile == 'text/html' && fieldType == 'html') {
          return true
        }

        if ((typeFile == 'application/zip' && fieldType == 'zip') || (typeFile == 'application/x-zip-compressed' && fieldType == 'zip')) {
          return true
        }

        return false
      }

      return false
    },

    clearUpload(field) {
      this[`${field}FileName`] = ''
      this[field] = {}
    },

    submit() {
      this.loading = true
      let formData = new FormData()
      this.messagesSend = []

      try {
        if (this.isDestinationTypeCampaign) {
          formData.append('campaignId', this.$route.params.dynamicId)
        }

        if (this.isDestinationTypeWorkflow) {
          formData.append('workflowId', this.$route.params.dynamicId)
        }

        if (this.urlField) {
          formData.append('Url', this.urlField)
          formData.append('Name', this.templateName)
        } else {
          formData.append('Name', this.templateName)
          formData.append('TemplateHTMLFile', this.html)
          formData.append('TemplateOptionalFile', this.zip)
        }
      } catch (error) {
        this.messagesSend = [getErrorMessage(error?.response?.data)]
      }
      let organizationId = this.$store.state.auth.organizationId

      services
        .sendTemplatesEmail(organizationId, formData)
        .then((result) => {
          this.messagesSend.push({
            status: 'success',
            text: 'Next Step',
          })

          const TEMPLATE = result.data.data

          const params = {
            id: TEMPLATE.emailTemplateId,
            ...this.$route.params,
          }
          this.$router.push({ name: 'import-confirm', params })
        })
        .catch((error) => {
          this.messagesSend = [getErrorMessage(error?.response?.data)]
        })
        .finally(() => {
          this.loading = false
        })
    },

    back() {
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss" scoped>
.box {
  border: 1px solid var(--gray-500);
  min-height: 250px;
}

.text-max-size {
  font-size: $font-size-xs;
  color: $gray-500;
}
</style>
